import verificationRequest from './verification_request'
import auth from './auth'
import task from './task'
import order from './order'

export default {
  verificationRequest,
  auth,
  task,
  order,
}
